export class CrmUsersNameVM {
    userId: number;
    firstName: string;
    display : string;
    value : number;
}
